import { useAppDispatch, useAppSelector } from "@app/store";
import { useUserId } from "@hooks/use-user-id";
import { useCallback } from "react";
import { OrderCSVRequest } from "./api";
import { getOrderCSV } from "./slice";

export const useGeneral = () => {
  const userId = useUserId();
  const state = useAppSelector((state) => state.general);
  const dispatch = useAppDispatch();

  const getOrderCSVHandler = useCallback(
    (data: OrderCSVRequest) => dispatch(getOrderCSV({ userId, data })),
    [dispatch, userId]
  );

  return {
    state,
    getOrderCSV: getOrderCSVHandler,
  };
};
